import React from 'react';
import { Globe, Languages, ToggleLeft, ToggleRight, CheckCircle, XCircle } from 'lucide-react';
import { TextInput } from '../../common/TextInput';
import { TextArea } from '../../common/TextArea';
import { CheckboxToggle } from '../../common/CheckboxToggle';

export default function BasicInfoTab({ values, setField, t }) {
  return (
    <div className="space-y-8">
      {/* Status Toggle - At the top for visibility */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center">
              <h3 className="text-lg font-semibold text-gray-900 mr-3">
                {t('subscriptionStatus')}
              </h3>
              <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                values.isActive 
                  ? "bg-green-100 text-green-800" 
                  : "bg-gray-100 text-gray-800"
              }`}>
                {values.isActive ? (
                  <>
                    <CheckCircle className="w-4 h-4 mr-1" />
                    {t("active")}
                  </>
                ) : (
                  <>
                    <XCircle className="w-4 h-4 mr-1" />
                    {t("inactive")}
                  </>
                )}
              </span>
            </div>
            <div className="text-sm text-gray-600 mt-1 flex items-center">
              <Globe className="w-4 h-4 mr-1" />
              {values.isActive ? t("visibleToCustomers") : t("hiddenFromCustomers")}
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <button
              type="button"
              onClick={() => setField("isActive", !values.isActive)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                values.isActive ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  values.isActive ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Subscription Names */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
            <Languages className="w-5 h-5 text-blue-600" />
          </div>
          {t('subscriptionNames')}
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <TextInput
            label={t("englishName")}
            name="nameEn"
            value={values.nameEn}
            placeholder={t("englishNamePlaceholder")}
            onChange={(e) => setField("nameEn", e.target.value)}
            required
          />
          <TextInput
            label={t("arabicName")}
            name="nameAr"
            value={values.nameAr}
            placeholder={t("arabicNamePlaceholder")}
            onChange={(e) => setField("nameAr", e.target.value)}
            required
            dir="rtl"
          />
        </div>
      </div>

      {/* Descriptions */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
          <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
            <Globe className="w-5 h-5 text-green-600" />
          </div>
          {t('descriptions')}
        </h3>
        <div className="space-y-6">
          <TextArea
            label={t("englishDescription")}
            name="descriptionEn"
            value={values.descriptionEn}
            placeholder={t("englishDescriptionPlaceholder")}
            onChange={(e) => setField("descriptionEn", e.target.value)}
            rows={4}
          />
          <TextArea
            label={t("arabicDescription")}
            name="descriptionAr"
            value={values.descriptionAr}
            placeholder={t("arabicDescriptionPlaceholder")}
            onChange={(e) => setField("descriptionAr", e.target.value)}
            rows={4}
            dir="rtl"
          />
        </div>
      </div>
    </div>
  );
}
